'use client'
import type { FC } from 'react'
import { CheckoutCartItemSingle } from './CartItemSingle/CheckoutCartItemSingle'
import { CheckoutCartItemGroup } from './CartItemGroup/CheckoutCartItemGroup'
import { type CheckoutCartItemProps } from './types'

export const CheckoutCartItem: FC<CheckoutCartItemProps> = ({
  cartItem,
  ...props
}: CheckoutCartItemProps) => {
  switch (cartItem.type) {
    case 'SINGLE':
      return <CheckoutCartItemSingle cartItem={cartItem} {...props} />
    case 'GROUP':
      return <CheckoutCartItemGroup cartItem={cartItem} {...props} />
  }
}
